import { ensureExhaustive } from "@b2bportal/core-utilities";
import { type Initial, LodgingSelectionEnum } from "@b2bportal/lodging-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import type { HotelsState } from "../../../../store";
import {
  type AvailabilityApiCall,
  fetchAvailabilityByLodgingId,
  fetchAvailabilityByPlaceAPI,
  fetchInitialAvailabilityByLocation,
} from "./api/fetchAvailability";

export const fetchInitialHotels = createAsyncThunk<
  Initial & { searchId: string },
  AvailabilityApiCall,
  { state: HotelsState; rejectValue: { error: string } }
>("hotelsAvailability/fetchInitialHotels", async (req, thunkAPI) => {
  const state = thunkAPI.getState();
  const { requestedSearch } = state.hotels.hotelsAvailability;

  if (requestedSearch == null) {
    return thunkAPI.rejectWithValue({ error: "Search is empty" });
  }

  try {
    const fetchAvailability = () => {
      const { LodgingSelection, request } = req;

      switch (LodgingSelection) {
        case LodgingSelectionEnum.Place:
          return fetchAvailabilityByPlaceAPI(request);

        case LodgingSelectionEnum.Location:
          return fetchInitialAvailabilityByLocation(request);

        case LodgingSelectionEnum.LodgingIds:
          return fetchAvailabilityByLodgingId(request);

        default:
          ensureExhaustive(LodgingSelection);
      }
    };

    const result = await fetchAvailability();
    return { ...result, searchId: uuidv4() };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue({ error: errorMessage });
  }
});
